import React, { FC, ComponentType } from 'react'
import RouteBasedLoadingPage from './RouteBasedLoadingPage'
export interface LoadingPageContextProps {
  component: ComponentType
}

export const LoadingPageContext = React.createContext<LoadingPageContextProps>({
  component: RouteBasedLoadingPage,
})

export const LoadingPageProvider: FC<{
  component?: ComponentType
}> = ({ component = RouteBasedLoadingPage, children }) => {
  return (
    <LoadingPageContext.Provider value={{ component }}>
      {children}
    </LoadingPageContext.Provider>
  )
}
